const constants = {
  TOGGLE_DARK_MODE: 'TOGGLE_DARK_MODE'
}

export default constants
